import { render, staticRenderFns } from "./IT2104List.vue?vue&type=template&id=1d238754&scoped=true&"
import script from "./IT2104List.vue?vue&type=script&lang=ts&"
export * from "./IT2104List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d238754",
  null
  
)

export default component.exports